// extracted by mini-css-extract-plugin
export default {"componentWrapper":"RemoveExport_componentWrapper__pA9ya","actions":"RemoveExport_actions__yKtuV"};